import {
	PriceDisplayRule,
	SimpleDisplayPrice,
	AmbiguousDisplayPrice,
} from '../../../../../Roc.SharedClientApp/types/commerce/display-price';
import { GetPricingLine, GetPriceForQuantity } from '../pricing/pricing-result';
import { ProductDetailsState } from './types';

export const GetSalePercentageSummary = (productDetails: ProductDetailsState) => {
	if (productDetails.displayPricing == null) {
		throw new Error("Display pricing was rendered when it wasn't ready!");
	}
	const selectedPricingLineId =
		productDetails.pricingLines && productDetails.pricingLines.selected && productDetails.pricingLines.selected.id;

	const displayPriceLine = GetPricingLine(productDetails.displayPricing, productDetails.id, selectedPricingLineId);

	const displayPrice = displayPriceLine && GetPriceForQuantity(displayPriceLine.prices, 1);

	let discount: number = 0;

	if (!displayPrice) {
		return discount;
	}
	switch (displayPrice.displayRule) {
		case PriceDisplayRule.Normal:
			discount = getSimpleDiscount(displayPrice);
			break;

		case PriceDisplayRule.AmbiguousRange:
			discount = getAmbiguousDiscount(displayPrice);
			break;
	}

	return discount;
};

export const getSimpleDiscount = (price: SimpleDisplayPrice) => {
	let discount: number = 0;
	if (price.salePrice?.rawValue) {
		const basePrice = Number(price.basePrice.rawValue);
		const salePrice = Number(price.salePrice.rawValue);

		discount = 100 - (100 * salePrice) / basePrice;
	}
	return Math.round(discount);
};

export const getAmbiguousDiscount = (price: AmbiguousDisplayPrice) => {
	let discount: number = 0;
	if (price.salePrice?.rawValue) {
		const basePrice = Number(price.basePrice.rawValue);
		const salePrice = Number(price.salePrice.rawValue);

		discount = 100 - (100 * salePrice) / basePrice;
	}
	return Math.round(discount);
};
